import { createI18n } from '../plugins/i18n';
import merge from 'lodash.merge';

const LANGS = ['en', 'ja', 'ko', 'pt'];

export function pageLocale(): 'en' | 'ja' | 'ko' | 'pt' {
  const element = (<HTMLInputElement>document.getElementById('locale'));
  const locale = element !== null ? element.value as 'en' | 'ja' | 'ko' | 'pt' : 'en';

  return locale;
}

export function localeMessages(localesForLang: (lang: string) => any[]) {
  const messages: any = {};

  for (const lang of LANGS) {
    messages[lang] = {};
    let messagesForLocale: any = [];

    try {
      messagesForLocale = localesForLang(lang);
    } catch(err) {
      if (err instanceof Error && err.message.startsWith('Cannot find module')) {
        console.warn(`Translation file for ${lang} not found. Original error message: `, err.message);
      } else {
        throw err;
      }
    }

    for (const messageHash of messagesForLocale) {
      merge(messages[lang], messageHash[lang]);
    }
  }

  return messages;
}

// Example usage:
//
//   import { createVueI18n } from '../locale.ts'
//   createVueI18n((lang) => [
//     require(`locales/admin/${lang}.yml`),
//     require(`locales/simple_form/${lang}.yml`),
//   ]);
//
// Webpack will dynamically load all files under "locales/admin" and
// "locales/simple_form" when it sees interpolation in require statements
// like that. Be careful to not accidentally pull in all of "locales".
export function createVueI18n(localesForLang: (lang: string) => any[]) {
  return createI18n({
    locale: pageLocale(),
    messages: localeMessages(localesForLang)
  });
}
